import { trainingsRoutes } from 'modules/trainings/routes/constants';

export const trainingsLessonsRoutes = {
  root: `${trainingsRoutes.authenticated}/:trainingId`,
};
